<fieldset>
	@if (legend) {
		<legend>{{ legend }}{{ control.validator ? ' *' : '' }}</legend>
	}
	<mat-selection-list [formControl]="control">
		@for (value of values; track value) {
			<mat-list-option [value]="value" color="primary" togglePosition="before">{{ value | enumToLabel: labels }}</mat-list-option>
		}
	</mat-selection-list>
</fieldset>
@if (errorText && control.invalid) {
	<mat-error>{{ errorText }}</mat-error>
}
